export var selectOngoingPlayerProfileInfo = function (state) {
    return state.selectedPlayerProfile;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectOngoingPlayerProfileInfo.ts
// module id = 361
// module chunks = 3